/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
const awsmobile = {
  aws_project_region: "ap-northeast-2",

  Auth: {
    region: "ap-northeast-2",
    userPoolId: "ap-northeast-2_PjbXjneEV", // Please change this value.
    userPoolWebClientId: "7gud0b3ko5j832849c6of1ifp8", // Please change this value.
    identityPoolId: "ap-northeast-2:04103fe1-c38e-4383-8482-baaa311a2486", // Please change this value.
  },
  Storage: {
    AWSS3: {
      bucket: "thdlivedev-s3managerstack-master-attach-ap-northeast-2-64205",
      region: "ap-northeast-2",
    },
  },
  aws_cloud_logic_custom: [
    {
      name: "AdminApi",
      endpoint: "https://live-api-dev.hd-smartstore.com/admin",
      region: "ap-northeast-2",
    },
    {
      name: "MainApi",
      endpoint: "https://live-api-dev.hd-smartstore.com/admin",
      region: "ap-northeast-2",
    },
    {
      name: "ChannelApi",
      endpoint: "https://live-api-dev.hd-smartstore.com/admin",
      region: "ap-northeast-2",
    },
    {
      name: "IotApi",
      endpoint: "https://live-api-dev.hd-smartstore.com/admin",
      region: "ap-northeast-2",
    },
    {
      name: "ExtApi",
      endpoint: "https://live-api-dev.hd-smartstore.com/ext",
      region: "ap-northeast-2",
    },
  ],
};

export default awsmobile;
